import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable()
export class HttpGetUuidInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestUrl;
     try{
       requestUrl = new URL(req.url)
     }catch (e){
       // for httpClient request with relative URL
       requestUrl = new URL(`${window.location.protocol}//${window.location.host}/`)
     }
    const routeUrl = new URL(window.location.href.replace("/#/", "/"))
    let uuid = routeUrl.searchParams.get("uuid")
    if (req.method === 'GET' && uuid && requestUrl.pathname.startsWith("/api/")) {
      const httpRequest = req.clone({params: req.params.append('uuid', uuid)});
      return next.handle(httpRequest);
    } else {
      return next.handle(req);
    }
  }

}
